import React, { useState, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { apiUrl } from "../commons/inFormTypes";
import { IPUrl } from "../commons/IPAddress";
import SmoothList from "react-smooth-list";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Ssn_505343020 from '../../src/assets/img/Ssn_505343020.jpg'
import Transportation from '../../src/assets/img/Transportation.gif'
import Ssn_774994776 from '../../src/assets/img/Ssn_774994776.jpg'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Dashboard() {
  const [seenFile, setSeenFile] = useState([]);
  const userToken = localStorage.getItem("user_token");
  const navigate = useNavigate();

  const [search, setSearch] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [place, setPlace] = useState("");
  const [placeid, setPlaceId] = useState(0);
  const [placeList, setPlaceList] = useState([]);

  useEffect(() => {
    if (userToken == null) {
      navigate("/");
    } else {
      const axios = require("axios");
      axios({
        method: "post",
        url: apiUrl + "list",
        headers: {
          'Access-Control-Allow-Origin': "*",
          Accept: "application/json",
          Authorization: "Bearer " + userToken,
        },
      }).then((res) => {
        if (res.data.success) {
          setSeenFile(res.data.result);
        } else {
        }
      });
    }
  }, []);

  const HandleSearch = (data) => {
    navigate(`/admin/service/${data.url}`)
  };


  const HandleChange = (e) => {
    setPlace(e.target.value);
    setSearch(false);
    setNotFound(false);

    if (e.target.value.length >= 3) {
      var data = new FormData();

      data.append("q", e.target.value);

      const axios = require("axios");
      // setSnip(true);
      axios({
        method: "post",
        url: apiUrl + "subject-search",
        headers: {
          'Access-Control-Allow-Origin': "*",
          Accept: "application/json",
          Authorization: "Bearer " + userToken,
        },
        data: data,
      })
        .then((res) => {
          // setSnip(false);
          if (res.data.success) {
            setSearch(true);
            setPlaceList(res.data.result);
          } else {
            setNotFound(true);
            setSearch(true);
          }
        })
        .catch(function (error) {
          // setSnip(false);
          setSearch(true);
          setNotFound(true);

        });
    } else setSearch(false);
    setPlaceList([]);
  };


  return (
    <div>
      <main>
        <div className="pt-3 pt-lg-5">
          <Container className="m-auto">
            <Row className="justify-content-center mb-3 no-gutters">
              <Col xs={12} md={11} lg={9} className="mt-3">
                <Row className="justify-content-start g-2 g-sm-4">
                  <Col xs={12} style={{ direction: "ltr" }} className="d-block d-lg-none my-3">
                    <Carousel
                      autoPlay={true}
                      showThumbs={false}
                      infiniteLoop={true}
                      interval={3000}
                      dynamicHeight={true}                       
                      swipeable={true}
                      emulateTouch={true}
                    >
                      <div>
                        <img className="rgc-carousel" src={Ssn_505343020} alt="Chrysanthemum" />
                      </div>
                      <div>
                        <img className="rgc-carousel" src={Transportation} alt="Hydrangeas" />
                      </div>
                      <div>
                        <img className="rgc-carousel" src={Ssn_774994776} alt="Jellyfish" />
                      </div>

                    </Carousel>
                  </Col>

                  <Col xs={12} className="rgc-search mt-sm-4 mb-2 g-0">
                    <form>
                      <input
                        className="form-control rgc-search"
                        type="search"
                        placeholder="جستجوی سریع خدمات..."
                        aria-label="Search"
                        value={place}
                        onChange={(e) => HandleChange(e)}
                      />
                    </form>
                    {/* {(search && !notFound) ? {
                      return(
                        <ul>
                        {placeList.map((item) => 
                        <li key={item.id}
                        onClick={(item) => HandleSearch(item)}>
                           {" "}{item.value}
                        </li>
                        )}
                       </ul>

                      )
                    }
                    :
                    <i>موردی یافت نشد</i>
                    
                    } */}

                       {search &&
                      <div className="rgc-search-input">
                        <ul>
                          {(notFound === false) ? 
                           placeList.map((item, index) => (
                            <li
                              key={item.id}
                              onClick={() =>
                                HandleSearch(item)
                              }
                            >
                              {" "}
                              {item.value}
                            </li>
                          ))
                        :
                        <li>موردی یافت نشد </li>
                        }
                           
                        </ul>
                      </div>
                       }


                  </Col>

                  {seenFile.map((data, index) => {
                    return (
                      <Col key={index} xs={4} md={4} lg={3} className="sub-side">
                        <SmoothList
                          delay={200}
                          animated={true}
                          visible={true}
                          transitionDuration={400}
                        >

                          {data.url !== null ?
                            <NavLink to={`/admin/service/${data.url}`}>
                              <div className="card rgc-card">
                                <div className="card-body my-1">
                                  <img src={IPUrl + data.image}
                                    alt=""
                                    className="rgc-img-dash img-fluid mt-sm-3" />
                                  <h6 className="card-title mt-2 mt-sm-3">{data.title}</h6>
                                </div>
                              </div>
                            </NavLink>
                            :
                            <NavLink to={`/admin/items/${data.id}`}>

                              <div className="card rgc-card"  >
                                <div className="card-body my-1">
                                  <img src={IPUrl + data.image}
                                    alt=""
                                    className="rgc-img-dash img-fluid mt-sm-3" />
                                  <h6 className="card-title mt-2 mt-sm-3">{data.title}</h6>
                                </div>
                              </div>
                            </NavLink>
                          }
                        </SmoothList>
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            </Row>
          </Container>
          <div className="rgc-toast">
            <ToastContainer autoClose={3000} />
          </div>
        </div>
      </main>
    </div>
  );
}

export default Dashboard;
